/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_addPositionToEventCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', function ($rootScope, $scope, $http, NetworkService, MainService) {


        $scope.createPosition = function ()
        {
            var event = MainService.getEventData()
            var picTure = MainService.getProfilePic();
            var text = $("#posText").val();
            var descr = $scope.position_description;
            var addToThisEvent = $("#posEventId").val();
            var event_id = -1

            /**
             * Absichtlich 0 und 1 vertauscht
             */
            if ($scope.positionAdminApproval)
            {
                var needsApproval = 0
            } else
            {
                needsApproval = 1
            }

            if ($scope.isPairPosition)
            {
                var isPairPosition = 1
            } else
            {
                isPairPosition = 0
            }

            if (addToThisEvent == "on")
            {
                event_id = $scope.event.event_id
            }

            NetworkService.addPosition(text, descr, event_id, picTure, needsApproval, isPairPosition, $scope.isLeadingOrFollowingPosition, $scope.hasTshirt, function (data) {
                $rootScope.$emit("repaint")

                $rootScope.$emit("saveAddPositionAddGroups", data.id)
            });
            /*
             var req = {
             method: 'POST',
             url: "Api/hosiapi.php",
             data: $.param(fields),
             headers: {'Content-Type': 'application/x-www-form-urlencoded'},
             }
             $http(req).then(function (data) {
             $scope.positionen = data.data["positionen"];
             if (data.data.length == 0)
             {
             
             } else
             {
             //$scope.renderCalendar(data)
             }
             
             }, "json");*/
        }
    }])